module.exports = __webpack_public_path__ + "img/arrow.d242650d.svg";